<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="d-flex align-items-start my-2 w-100" id="live-feed-top"
      :class="{ 'flex-column justify-content-start': stacked, 'flex-row justify-content-between': !stacked }" v-for="row in pagedRows">
        <span class="m-0"><strong>{{ row.name }}</strong>{{ row.text }}</span>
        <span class="d-block text-muted">{{ row.timeAgo }}</span>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center w-100" v-if="!hidePagination">
      <b-pagination v-model="page" :per-page="limit" :total-rows="validRows.length"/>
    </div>
  </div>
</template>

<script>
import distanceInWords from 'date-fns/distance_in_words';
import timeNowMixin from '@src/mixins/timeNow';
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    users: {
      type: Array,
      required: true,
    },
    history: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      default: 10,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ timeNowMixin ],
  data: () => ({
    page: 1,
  }),
  computed: {
    ...mapRoot([ 'userID' ]),
    buildTextFromLog() {
      return {
        JOB_SHARED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.share-text') };
        },
        REFERRAL_SUGGESTED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.referral-text') };
        },
        REFERRAL_ACCEPTED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.referral-text') };
        },
        REFERRAL_SHARED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.referral-text') };
        },
        EVENT_REFERRAL_CREATED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.referral-text') };
        },
        CONTENT_SHARED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.content-share-text') };
        },
        JOB_BROWSE_LINKEDIN({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.referral-text') };
        },
        JOB_SCHEDULE_SHARE_FIRST({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.referral-text') };
        },
        CONTENT_SCHEDULE_SHARE_FIRST({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.content-share-text') };
        },
        APPLICATION_CREATED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.application-text') };
        },
        APPLICATION_CONFIRMED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.application-confirmed-text') };
        },
        APPLICATION_INTERVIEW({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.interview-text') };
        },
        APPLICATION_HIRED({ userID }) {
          return { name: this.getUserFullName(userID), text: this.$t('campaign.live-feed.hire-text') };
        },
      };
    },
    usersByID() {
      return this.users.reduce((lookup, user) => {
        lookup[user.id] = user;
        return lookup;
      }, {});
    },
    validRows() {
      const { buildTextFromLog } = this;
      const validEventNames = Object.keys(buildTextFromLog);
      return this.history.filter(row => row && validEventNames.includes(row.eventName));
    },
    pagedRows() {
      const { buildTextFromLog } = this;
      return this.validRows.slice(Math.max(0, this.page - 1) * this.limit, this.page * this.limit).map(row => {
        const { eventName } = row;
        const { [eventName]: buildText } = buildTextFromLog;
        return {
          ...row,
          ...buildText.call(this, row),
          timeAgo: distanceInWords(this.timeNow, row.timestamp, {
            includeSeconds: true,
            addSuffix: true,
          }),
        };
      });
    },
  },
  methods: {
    getUserFullName(userID) {
      if (this.userID === userID) {
        return 'You';
      } else {
        const { fullName } = this.usersByID[userID];
        return fullName;
      }
    },
  },
  watch: {
    page() {
      if (this.$el.querySelector('#live-feed-top')) {
        this.$scrollTo('#live-feed-top');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/referral-jam/LiveFeed.vue